import {Card, CardActionArea, Stack, styled} from '@mui/material';
import {IconIllustration} from 'presentation/components/IconIllustration';
import {StyledCardActionAreaProps, StyledCardProps} from './types';

const StyledCardActionArea = styled(CardActionArea)<StyledCardActionAreaProps>`
	border-radius: 8px;

	${({theme}) => theme.breakpoints.up('md')} {
		max-width: ${({$hasMaxWidth}) => ($hasMaxWidth ? '500px' : 'none')};
	}
`;

const StyledCard = styled(Card)<StyledCardProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${({size}) => (size === 'medium' ? '16px' : '24px 16px')};
	border: none;
`;

const StyledStack = styled(Stack)`
	flex-direction: row;
	align-items: center;
	gap: 8px;
	font-size: 0.875rem;
`;

const StyledIconButtonContainer = styled('div')`
	display: flex;
	align-items: center;
`;

const StyledIconIllustration = styled(IconIllustration)`
	background-color: ${({theme}) => theme.palette.other.inversedColorIconBg};
`;

export {
	StyledCardActionArea,
	StyledCard,
	StyledStack,
	StyledIconButtonContainer,
	StyledIconIllustration,
};
